// extracted by mini-css-extract-plugin
module.exports = {"rating":"BusinessRating_rating__2Hu56"};